import { useSubmitPhoneNumberMutation } from '@twisto/api-graphql'
import type { CastedSubmitHandler } from '@twisto/components/atoms/form'
import { useForm } from '@twisto/components/atoms/form'
import { useResponseErrors } from '@twisto/form'

import { FlowForm } from '../../components'
import { useFlow } from '../../flow/flow.context'

import type { FormValues } from './phone-number-step-form-content'
import { PhoneNumberStepFormContent } from './phone-number-step-form-content'
import { PhoneNumberStepHeadline } from './phone-number-step-headline'

export const PhoneNumberStep = () => {
  const { flow, sessionId } = useFlow<'PhoneNumberStep'>()
  const [submitPhoneNumber, { data }] = useSubmitPhoneNumberMutation()
  const { phoneNumber } = flow.currentStep
  const defaultPhoneNumber = phoneNumber.value
  const callingCodes = phoneNumber.availableCallCodes

  const formContext = useForm<FormValues>({
    defaultValues: {
      phoneNumber: {
        callingCode: defaultPhoneNumber?.callCode ?? callingCodes[0],
        nationalNumber: defaultPhoneNumber?.nationalNumber ?? '',
      },
    },
  })

  // handle field errors - such a invalid email
  useResponseErrors(data?.submitPhoneNumber, formContext)

  const handleSubmit: CastedSubmitHandler<FormValues> = ({ phoneNumber }) =>
    submitPhoneNumber({
      variables: {
        auth: { sessionId },
        input: {
          phoneNumber: {
            callCode: phoneNumber.callingCode,
            nationalNumber: phoneNumber.nationalNumber,
          },
        },
      },
    })

  return (
    <>
      <PhoneNumberStepHeadline />
      <FlowForm {...formContext} onSubmit={handleSubmit}>
        <PhoneNumberStepFormContent />
      </FlowForm>
    </>
  )
}
